import { Container } from "react-bootstrap";
import { Form } from "@/ui/Form";
import clsx from "classnames";
import classes from "./styles.module.scss";

export const FormSection = ({
  formName = "",
  className,
  title = "Register your interest here",
  content = "<p>Complete the form below</p>",
  form,
  successPageUrl = "/contact-us/submission-complete",
}) => {
  const heading = title || "Register your interest here";
  const text = content || "<p>Complete the form below</p>";

  const onSubmitDone = () => {
    if (typeof window !== "undefined") {
      window.location.href = successPageUrl;
    }
  };

  return (
    <div className={className} id={formName}>
      <Container className="px-0">
        <div className={clsx(classes.form, "p-4 p-md-5")}>
          <h4 className="mb-2">{heading}</h4>
          <div className="mb-4" dangerouslySetInnerHTML={{ __html: text }} />

          <Form formId={form} onSubmitDone={onSubmitDone} />
        </div>
      </Container>
    </div>
  );
};

export default FormSection;
